import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DeleteModal from '../DeleteModal';
import * as listActions from '../../../actions/lists';

const propTypes = {
  data: PropTypes.object.isRequired,
  deleteList: PropTypes.func.isRequired
};

const DeleteListModal = ({ data, deleteList, ...props }) => (
  <DeleteModal
    id="delete-list-modal"
    title="List"
    itemTitle={data.title}
    deleteItem={() => deleteList(data.hotelId, data.id)}
    {...props}
  />
);

DeleteListModal.propTypes = propTypes;

export default connect(
  null,
  listActions
)(DeleteListModal);
